import { render, staticRenderFns } from "./SearchOrdersHeader.vue?vue&type=template&id=21dcc152&"
import script from "./SearchOrdersHeader.vue?vue&type=script&lang=js&"
export * from "./SearchOrdersHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchOrdersHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports